import React from 'react';
import { Card, Alert, Spinner } from 'react-bootstrap';
import { Server, Check, AlertTriangle } from 'lucide-react';
import { useBackendInfo } from '../../hooks/superadmin/useBackendInfo';
import { isBackendOutdated, REQUIRED_BACKEND_LEVEL } from '../../utils/backendLevel';

/** The deployed backend level next to the level this web build needs (read-only). */
const BackendLevelCard: React.FC = () => {
    const backend = useBackendInfo();

    return (
        <Card className="mb-4">
            <Card.Header className="d-flex align-items-center gap-2">
                <Server size={18} />
                Backend
            </Card.Header>
            <Card.Body className="p-4">
                <p className="text-muted mb-3">
                    Webbappen kräver en lägsta backendnivå. Nivån sparas när mf-functions
                    driftsätts till instansen.
                </p>

                {backend.status === 'loading' && <Spinner animation="border" size="sm" />}

                {backend.status === 'error' && (
                    <Alert variant="danger" className="mb-0">
                        Kunde inte läsa backendnivån
                    </Alert>
                )}

                {backend.status === 'loaded' && (
                    <>
                        {isBackendOutdated(backend.info) ? (
                            <Alert variant="danger" className="d-flex align-items-center gap-2">
                                <AlertTriangle size={18} className="flex-shrink-0" />
                                {backend.info
                                    ? 'Backend är äldre än webbappen kräver. Driftsätt mf-functions till instansen.'
                                    : 'Backend har inte driftsatts sedan nivåkontrollen infördes. Driftsätt mf-functions till instansen.'}
                            </Alert>
                        ) : (
                            <Alert variant="success" className="d-flex align-items-center gap-2">
                                <Check size={18} className="flex-shrink-0" />
                                Backend är uppdaterad
                            </Alert>
                        )}

                        <dl className="row mb-0 small">
                            <dt className="col-sm-5">Driftsatt nivå</dt>
                            <dd className="col-sm-7">{backend.info ? backend.info.level : 'Saknas'}</dd>
                            <dt className="col-sm-5">Krävs av webbappen</dt>
                            <dd className="col-sm-7">{REQUIRED_BACKEND_LEVEL}</dd>
                            {backend.info?.commit && (
                                <>
                                    <dt className="col-sm-5">Commit</dt>
                                    <dd className="col-sm-7"><code>{backend.info.commit}</code></dd>
                                </>
                            )}
                            {backend.info?.deployedAt && (
                                <>
                                    <dt className="col-sm-5">Driftsatt</dt>
                                    <dd className="col-sm-7">{backend.info.deployedAt}</dd>
                                </>
                            )}
                        </dl>
                    </>
                )}
            </Card.Body>
        </Card>
    );
};

export default BackendLevelCard;
